module.exports = __webpack_public_path__ + "img/appDown.e6a5f1d2.jpg";